
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { RetentionPolicyFormValues } from '../schemas/retentionPolicySchema';

interface RetentionYearsFieldProps {
  form: UseFormReturn<RetentionPolicyFormValues>;
}

export function RetentionYearsField({ form }: RetentionYearsFieldProps) {
  return (
    <FormField
      control={form.control}
      name="retention_years"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Retention Years</FormLabel>
          <FormControl>
            <Input 
              type="number" 
              {...field}
              onChange={e => field.onChange(parseInt(e.target.value))}
            />
          </FormControl>
          <FormDescription>
            Number of years to retain records before archiving
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
